import { useMutation } from '@tanstack/react-query'
import { galaRsvpRepository } from '../repositories/galaRsvpRepository'
import type { CreateGalaRsvpInput } from '@/lib/types/galaRsvp'

export const useSubmitGalaRsvp = () =>
  useMutation({
    mutationFn: async (input: CreateGalaRsvpInput) =>
      galaRsvpRepository.createRsvp(input),
  })
